module.exports = __webpack_public_path__ + "assets/img/img1-0bdf0f83.png";